import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

type Props = {
  id?: string;
  title?: string;
  hideActionButton?: boolean;
  isActionDisabled?: boolean;
  actionButtonText?: string;
  actionButtonType?: 'Success' | 'Danger';

  hideCancelButton?: boolean;
  cancelButtonText?: string;

  onClose: () => void;
  onCancelClick?: () => void;
  onActionClick?: () => void;

  children: React.ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl';
};

const Modal = ({
  id,
  title,
  hideActionButton = false,
  isActionDisabled,
  actionButtonText = 'Ok',
  actionButtonType,

  hideCancelButton = false,
  cancelButtonText = 'Cancel',
  onClose,
  onCancelClick,
  onActionClick,

  children,
  size
}: Props) => {
  const ignoreBodyClicks = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
  };

  const sizeToWidth: Record<NonNullable<Props['size']>, string> = {
    sm: '400px',
    md: '600px',
    lg: '700px',
    xl: '1000px'
  };

  const [container] = useState(() => {
    const div = document.createElement('div');
    div.className = 'modal-container';
    return div;
  });

  useEffect(() => {
    document.body.appendChild(container);
    return () => {
      document.body.removeChild(container);
    };
  }, [container]);

  return ReactDOM.createPortal(
    <div className="modal-space" onClick={onClose}>
      <div
        className="custom-modal"
        onClick={ignoreBodyClicks}
        id={id}
        style={{
          width: sizeToWidth[size]
        }}
      >
        <div className="modal-title">
          <h4>{title}</h4>
        </div>

        <div className="modal-contents">{children}</div>

        <div
          className="modal-buttons"
          hidden={hideActionButton && hideCancelButton}
        >
          {!hideActionButton && (
            <button
              onClick={onActionClick}
              disabled={isActionDisabled}
              className={
                actionButtonType === 'Danger'
                  ? 'danger-button btn'
                  : 'success-button btn'
              }
            >
              {actionButtonText}
            </button>
          )}
          {!hideCancelButton && (
            <button
              onClick={onCancelClick}
              className="cancel-button btn-text-only"
            >
              {cancelButtonText}
            </button>
          )}
        </div>
      </div>
    </div>,
    container
  );
};

export default Modal;
